import { useState } from "react";
import { db } from "../firebase/config";
import { doc, deleteDoc, runTransaction } from "firebase/firestore";


export const useDeleteDocument = () => {

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(null);

    // deal with memory leak
    // const [cancelled, setCancelled] = useState(false);

    async function deleteData(docCollection, id) {
        setLoading(true)
        setError(null)

        try {
            if (docCollection === 'transactions' || docCollection === 'day-off') {
                await runTransaction(db, async (transaction) => {
                    const documentRef = doc(db, docCollection, id);
                    const documentSnapshot = await transaction.get(documentRef);

                    if (documentSnapshot.exists()) {
                        const data = documentSnapshot.data();
                        const reservedSlots = Array.isArray(data.reservedSlots) ? data.reservedSlots : [];

                        reservedSlots.forEach((slotId) => {
                            transaction.delete(doc(db, 'slots', slotId));
                        });
                    }

                    transaction.delete(documentRef);
                });
            } else {
                await deleteDoc(doc(db, docCollection, id));
            }

            console.log('doc deleted')
            return true;
        } catch (error) {
            console.log(error.message)
            setError(error.message)
            return false;
        } finally {
            setLoading(false)
        }
    }

    return { deleteData, loading, error };
};
